// extracted by mini-css-extract-plugin
export default {"plansContainer":"Plans_plansContainer__J41xw","continueButton":"Plans_continueButton__QYUxj","linksContainer":"Plans_linksContainer__imP2a","link":"Plans_link__Np00q"};